// src/CoursesSection.js
import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Import Swiper's CSS for styling
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Import Swiper modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const CoursesSection = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const swiperRef = useRef(null);

  const openModal = (content) => {
    setModalContent(content);
    setModalVisible(true);
    if (swiperRef.current) {
      swiperRef.current.autoplay.stop();
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    setModalContent('');
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  };

  return (
    <section
      style={{
        padding: '1rem 0', // py-16
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Swiper
          modules={[Autoplay, Pagination, Navigation]} // Include Swiper modules here
          loop={true} // Loop the images
          spaceBetween={0}
          slidesPerView={1} // Only show 1 image at a time
          autoplay={{
            delay: 3000, // Auto slide every 3 seconds
            disableOnInteraction: false, // Keep auto-sliding even after user interacts
          }}
          pagination={{ clickable: true }} // Enable pagination controls (dots)
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }} // Enable navigation buttons
          style={{ width: '100%', height: '300px' }} // Set a specific height for the Swiper container
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {/* Beginner Igbo Course */}
          <SwiperSlide onClick={() => openModal('The Beginner Level: The beginner course includes up to 100 hours of instruction. It is designed to help learners with little or no experience start off their Igbo language journey. Learners will be introduced to essential vocabulary, greetings, common phrases, pronunciation, and simple sentence structures.')}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Frame 6.svg`}
              alt="Beginner Igbo"
              style={{
                width: '100%',
                height: '300px', // Set a specific height for the images
                objectFit: 'cover', // Ensure the image covers the full space without distortion
                cursor: 'pointer',
              }}
            />
          </SwiperSlide>

          {/* Intermediate Igbo Course */}
          <SwiperSlide onClick={() => openModal('The Intermediate Level: Learners at this level will expand their vocabulary, improve grammar, and develop conversational skills. This stage focuses on sentence formation and comprehension exercises to enhance fluency. Learners will be introduced to ilu okwu igbo.')}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Frame 7.svg`}
              alt="Intermediate Igbo"
              style={{
                width: '100%',
                height: '300px', // Set a specific height for the images
                objectFit: 'cover',
                cursor: 'pointer',
              }}
            />
          </SwiperSlide>

          {/* Advanced Igbo Course */}
          <SwiperSlide onClick={() => openModal('The Advanced Level: This level is for learners who want to achieve full proficiency in Igbo. It covers complex sentence structures, cultural nuances, idiomatic expressions, and advanced conversations. Students will also engage in reading and writing exercises to refine their skills. At this level, learners will be expected to explain complex thoughts, write, and read fluently in Igbo.')}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Frame 8.svg`}
              alt="Advanced Igbo"
              style={{
                width: '100%',
                height: '300px', // Set a specific height for the images
                objectFit: 'cover',
                cursor: 'pointer',
              }}
            />
          </SwiperSlide>
        </Swiper>

        {/* Navigation Buttons */}
        <div
          className="swiper-button-next"
          style={{
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            border: 'none',
            padding: '10px',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
        >
        </div>
        <div
          className="swiper-button-prev"
          style={{
            position: 'absolute',
            top: '50%',
            left: '10px',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            border: 'none',
            padding: '10px',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
        >
        </div>

        {/* Pagination */}
        <div className="swiper-pagination"></div>
      </div>

      {/* Call-to-Action Button */}
      <div
        style={{
          marginTop: '2rem',
        }}
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <a
          href="/register"
          style={{
            backgroundColor: '#ff7c0a',
            color: 'white',
            padding: '0.5rem 1rem', // sm:py-3 sm:px-6
            borderRadius: '0.5rem', // rounded-lg
            fontSize: '1rem', // sm:text-lg
            fontWeight: 'bold',
            textDecoration: 'none',
            transition: 'background-color 0.3s',
          }}
          className="hover:bg-[#e66b00] transition duration-300"
        >
          Register Now
        </a>
      </div>

      {/* Modal */}
      {modalVisible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#ff7c0a',
              color: 'black',
              padding: '2rem',
              borderRadius: '0.5rem',
              maxWidth: '500px',
              width: '90%',
              position: 'relative',
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: 'transparent',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
              }}
            >
              &times;
            </button>
            <p>{modalContent}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default CoursesSection;